import {
  DATO_DISCOUNT_FIELDS,
  getDatoMarket,
  getMarketORFilter,
  resolvePartnerDiscounts
} from '@shared/cart-js';
import { COUNTRY } from '@shared/cove-ui';
import Axios from 'axios';
import keyBy from 'lodash/keyBy';

const apiEnv =
  (typeof window !== 'undefined' && process.env.GATSBY_API_ENV) ||
  'development';

const token = '7c8a71c5a466ac293a9f9f29233e78';

/**
 *
 * @param {object=} params
 * @param {string=} params.partnerId
 * @param {'US' | 'CA'=} params.country
 */
const datoLoad = async ({
  partnerId = apiEnv !== 'production' ? '39770523' : '6400414',
  country = COUNTRY
}: {
  partnerId?: string;
  country?: 'US' | 'CA';
} = {}) => {
  const market = getDatoMarket(country);
  const marketsFilter = getMarketORFilter(market);

  return Axios.post(
    `https://graphql.datocms.com/${apiEnv !== 'production' ? '' : ''}`,
    {
      query: /* GraphQL */ `{
      allDiscounts(first: 100, orderBy: [priority_ASC, createdAt_ASC], filter: {OR: [${marketsFilter}], active: {eq: true}}) {
        ${DATO_DISCOUNT_FIELDS}
      }
      partner(filter: {partnerId: {eq: "${partnerId}"}}) {
        productsList {
          ...productFields
        }
        plansList {
          ...productFields
        }
      }
      partnerSalesConfig(filter: {partner: {eq: "${partnerId}"}}) {
        discountFilter
        discountsList {
          ${DATO_DISCOUNT_FIELDS}
        }
      }

      allProductCategories(first: 100) {
        id
        name
      }
      payLater {
        maximum
        minimum
        restrictTo {
          id
          sku
        }
      }
    }

    fragment productFields on ProductRecord {
      name
      sku
      createdAt
      pandoId
      productType
      price
      salePrice
      payLaterEligible
      description
      featureList {
        description
      }
      maximumSensorCountOnSite
      recommendation
      floorplanImage {
        url
      }
      primaryImage {
        url
      }
      category {
        name
        id
      }
      lowInventoryIcon
      outOfStock
      outOfStockAvailabilityText
      position
    }
    `
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      timeout: 5000
    }
  )
    .then(({ data: { data } }) => {
      data.payLater.restrictTo = data.payLater
        ? data.payLater.restrictTo.map(product => product.sku)
        : [];
      return {
        products: keyBy(
          [...data.partner.productsList, ...data.partner.plansList],
          'sku'
        ),
        discounts: resolvePartnerDiscounts({
          allDiscounts: data.allDiscounts ?? [],
          partnerSalesConfig: data.partnerSalesConfig,
          market
        }),
        payLater: data.payLater
      };
    })
    .catch(error => {
      console.error(error);
      return { error };
    });
};

export default datoLoad;
